import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NavParams } from '@ionic/angular';
import { Insomnia } from '@ionic-native/insomnia/ngx';
declare var particlesJS: any;

@Component({
  selector: 'app-meditation',
  templateUrl: './meditation.page.html',
  styleUrls: ['./meditation.page.scss'],
})
export class MeditationPage implements OnInit {
  public duration: number;
  public minutes: number;
  // myStyle: object = {};
  // myParams: object = {};
  // width = 100;
  // height = 100;

  constructor(
    public modalController: ModalController,
    public navParams: NavParams,
    private insomnia: Insomnia
  ) {
    this.insomnia.keepAwake()
    .then(
      () => console.log('insomnia success'),
      () => console.log('insomnia error')
    );
    // console.log(this.navParams.get('duration'));
  }

  ngOnInit() {
    particlesJS.load('particles-js', '../../assets/particlesjs-config.json', null);
    const n = this.navParams.get('duration') * 1000;
    this.minutes = n / 60000;
    this.duration = n;
  }

  async closeModal() {
    this.modalController.dismiss();
  }

}
